import { t } from '@superset-ui/core';
import { isValid, parseISO } from 'date-fns';

// //KR2-48436: Thêm hàm xử lý số âm dương, kiểu string
// export function checkSign(text: string) {
// 	// Sử dụng biểu thức chính quy để trích xuất số từ chuỗi
// 	const match = text.match(/([-+]?\d+\.\d+)%/);

// 	if (match) {
// 		const numericValue = parseFloat(match[1]);
// 		if (numericValue < 0) {
// 			return 'negative';
// 		} else if (numericValue > 0) {
// 			return 'positive';
// 		} else {
// 			return 'zero';
// 		}
// 	} else {
// 		return '';
// 	}
// }

//KR2-48436: Thêm hàm xử lý kiểm tra kiểu của một giá trị
export function checkType(input: any) {
	try {
		//kiểu object json
		try {
			const parsedObject = JSON.parse(input);

			if (typeof parsedObject === 'object') {
				return 'object';
			}
		} catch (error) {
			// Ignore the error and continue to the next check
		}

		//kiểu array
		if (Array.isArray(input)) {
			return 'array';
		}

		if (!input && input != 0) {
			return 'empty';
		}

		// Check if it's a number
		if (!isNaN(Number(input)) && !isNaN(parseFloat(input))) {
			return 'number';
		}

		// Check if it's a boolean
		if (typeof input === 'boolean') {
			return 'boolean';
		}

		// Check if it's a date
		try {
			if (isValid(parseISO(input))) {
				return 'date';
			}
		} catch {}

		// If it's not a number or date, consider it as a string
		return 'string';
	} catch {
		return '';
	}
}

//KR2-48876: Trả về string cho kiểu data
// NUMERIC = 0,
// STRING = 1,
// TEMPORAL = 2,
// BOOLEAN = 3,
// CHECKBOX = 4,
// RADIO = 5,
export function getNameType(input: number) {
	if (input == 0) {
		return 'number';
	} else if (input == 1) {
		return 'string';
	} else if (input == 2) {
		return 'date';
	} else if (input == 3) {
		return 'boolean';
	} else if (input == 4) {
		return 'checkbox';
	} else if (input == 5) {
		return 'radio';
	}
	return -1;
}

//Kv-xxx: Danh sách các tên cột tỷ lệ (được bổ sung trong view as tabe)
export const ClassWithColorSign = ['sale_rate', 'item2', 'item3'];

//Kv-xxx: Mapping giữa tên cột và multi language
export const listColumnLanguageMapping = {
	txn_date: 'Time',
	created_date: 'Time',
	sale_rate: 'Ratio',
	user_name: 'Employee',
	no_invoice: 'No invoice',
	net_revenue: 'Net revenue',
	profit: 'Profit',
	net_profit: 'Net profit',
	sale_revenue: 'Sale revenue',
	// 'COUNT(no_invoice)': 'Current period',
	// 'SUM(no_invoice)': 'Current period',
	// 'SUM(net_revenue)': 'Current period',
	// 'SUM(profit)': 'Current period',
	// 'SUM(net_profit)': 'Current period',
	// 'SUM(sale_revenue)': 'Current period',
	txn_month: 'Time',
	'txn-year': 'Time',
	// category_name_lv1: 'Category name',
	product_name: 'Product name',
	// count: 'Count',
	branch_name: 'Branch name',
};

export function ColumnSelectLanguageMapping(input: string): string {
	let result;
	switch (input) {
		case 'branch_name':
			result = t('All branches');
			break;
		case 'customer_group_name':
			result = t('All customer groups');
			break;
		case 'sale_channel_name':
			result = t('All sales channels');
			break;
		case 'category_name_lv1':
			result = t('All product groups');
			break;
		case 'retailer_id':
			result = t('All stores');
			break;
		case 'user_name':
			result = t('All sales staff');
			break;
		default:
			result = input;
	}
	return result;
}
